import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldAlert } from "lucide-react";

export default function AgeGate({ verified, onAccept }) {
  const [declined, setDeclined] = useState(false);

  if (verified) return null;

  return (
    <AnimatePresence>
      <motion.div
        data-testid="age-gate-overlay"
        className="fixed inset-0 z-[200] flex items-center justify-center bg-[#0B101C]/80 backdrop-blur-2xl px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          data-testid="age-gate-modal"
          className="w-full max-w-xl rounded-2xl border border-[rgba(200,169,106,0.35)] bg-[#141B2E]/90 backdrop-blur-2xl shadow-[0_8px_64px_rgba(0,0,0,0.8),0_0_80px_rgba(200,169,106,0.08)] p-10 sm:p-14"
          initial={{ opacity: 0, y: 40, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          {declined ? (
            <div data-testid="age-gate-declined-message" className="text-center space-y-6">
              <ShieldAlert className="mx-auto h-10 w-10 text-warning" strokeWidth={1.25} />
              <h2 className="font-serif text-3xl text-ink">Access declined</h2>
              <p className="text-sm text-[#B9BFCE] leading-relaxed">
                This site is restricted to researchers aged 21 and over who accept our research-use-only terms. Please close this tab.
              </p>
            </div>
          ) : (
            <div className="space-y-8">
              <div className="space-y-4">
                <div className="flex justify-center">
                  <span className="dog-tag dog-tag-sm text-[10px]">VF — Verified 21+ Only</span>
                </div>
                <p className="text-xs uppercase tracking-[0.3em] text-clinical text-center">Compliance Notice — VetForge Health &amp; Wellness</p>
                <h2 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight leading-none text-center">
                  Restricted access
                </h2>
              </div>
              <div className="space-y-4 text-sm text-[#B9BFCE] leading-relaxed">
                <p>
                  This website contains information about research peptides and laboratory diluents. By entering, you confirm that:
                </p>
                <ul className="space-y-2 text-xs uppercase tracking-[0.15em] text-warning">
                  <li>— You are 21 years of age or older</li>
                  <li>— All products are for laboratory research use only</li>
                  <li>— Products are not for human or veterinary consumption</li>
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 pt-2">
                <button
                  data-testid="age-gate-accept-button"
                  onClick={onAccept}
                  className="flex-1 bg-clinical text-[#0B101C] text-xs uppercase tracking-[0.2em] py-4 px-6 hover:bg-[#DBC28C] transition-colors duration-300"
                >
                  I am 21+ and accept
                </button>
                <button
                  data-testid="age-gate-decline-button"
                  onClick={() => setDeclined(true)}
                  className="flex-1 border border-[rgba(200,169,106,0.28)] text-[#B9BFCE] text-xs uppercase tracking-[0.2em] py-4 px-6 hover:bg-[#232B40] transition-colors duration-300"
                >
                  Decline
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
